import { LoadingOverlayService } from './../../services/loading-overlay.service';
import { Component, OnInit } from '@angular/core';

declare const google: any;

@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: [ './loading-overlay.component.scss' ]
})
export class LoadingOverlayComponent implements OnInit {

  constructor(
    public service: LoadingOverlayService
  ) { }

  ngOnInit(): void {
  }
}
